const Contact = () => {
  return (
    <div
      id="main"
      className="h-[calc(100vh-150px)] flex justify-center items-center bg-white dark:bg-black text-black dark:text-white"
    >
      <div className="fof">
        <h1 className="text-5xl inline-block">This is Contact Page</h1>
      </div>
    </div>
  );
};

export default Contact;
